
import { enTranslations } from './translations.en';
import { arTranslations } from './translations.ar'; // Import Arabic translations

export type Language = 'en' | 'ar';

export const translations = {
  en: enTranslations,
  ar: arTranslations, // Assign imported Arabic translations
};

// Fallback logic: If a key is missing in AR, use EN.
Object.keys(translations.en).forEach(key => {
  const enKey = key as keyof typeof translations.en;
  // Ensure arTranslations is treated as potentially having fewer keys than enTranslations
  // or keys that might not be strings yet (if they were, for instance, nested objects before fixing ar.ts)
  const arTranslationsTyped = translations.ar as Record<string, string | undefined>; 
  
  const arValue = arTranslationsTyped[enKey];

  if (arValue === undefined || (typeof arValue === 'string' && arValue.startsWith("[AR] "))) {
    // If the AR key is missing, or is still a placeholder, default to English
    arTranslationsTyped[enKey] = translations.en[enKey];
  }
});
